import { useField } from "formik";

import Box from "@mui/material/Box";

import TextField from "@components/Forms/FormInputs/TextField";
import FormLabel from "@components/Forms/FormLabel/Index";

export interface IFormFieldProperties {
  inputLabel?: string;
  isDisabled?: boolean;
  isMultiline?: boolean;
  name: string;
  rows?: number;
  stepLabel: string;
  stepNumber: number;
  tooltip: string;
}

/**
 * Renders a form field for the create campaign form.
 * @param name - The id of the form field.
 * @param stepLabel - Form Label text.
 * @param inputLabel - text directly connected to the form input.
 * @param tooltip - The tooltip of the form field.
 * @param stepNumber - The step number of the form field.
 * @param isMultiline - Whether the form field should be multiline.
 * @param rows - The number of rows for the form field.
 */
export default function FormField({
  inputLabel = "",
  isDisabled = false,
  isMultiline = false,
  name,
  rows = 1,
  stepLabel,
  stepNumber,
  tooltip,
}: IFormFieldProperties) {
  const [field] = useField(name);

  return (
    <Box>
      <FormLabel
        hasValue={!!field.value}
        label={stepLabel}
        name={name}
        stepNumber={stepNumber ?? null}
        tooltip={tooltip}
      />
      <TextField
        isDisabled={isDisabled}
        isFullWidth
        isMultiline={isMultiline}
        isRequired
        label={inputLabel}
        name={name}
        rows={isMultiline ? rows : undefined}
        size="small"
        type="text"
        variant="outlined"
      />
    </Box>
  );
}
